import {useMutation} from "react-query";
import axios from "services/axios";

export function useSuspendArticleUser(options = {}) {
	return useMutation(values => axios.put("/article/suspend-user", values).then(res => res.data), options);
}
